import { ColumnType, Row } from "@asayinc/component-library";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

import { IBankruptcyEvent } from "src/store/bankruptcyEvent/types";
import {
  BANKRUPTCY_CHAPTER_LABEL,
  BankruptcyChapter,
} from "src/constants/labels/bankruptcyEventLabel";

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const ISSUER_BANKRUPTCY_EVENTS_COLUMNS = [
  "recordDate",
  "filingDate",
  "chapter",
  "claimsAdministrator",
];

export type ColumnDataHelpers = {
  getSort: (sortKey: string) => "asc" | "desc" | undefined;
  onOrderingChange: (data: unknown, sortKey: string) => void;
};

export type IssuerBankruptcyEventsColumnData = {
  recordDate: ColumnType;
  filingDate: ColumnType;
  chapter: ColumnType;
  claimsAdministrator: ColumnType;
};

export function getColumns() {
  return ISSUER_BANKRUPTCY_EVENTS_COLUMNS;
}

export function getColumnData({
  getSort,
  onOrderingChange,
}: ColumnDataHelpers): IssuerBankruptcyEventsColumnData {
  return {
    recordDate: {
      sort: getSort("record_date"),
      sortFn: (data: unknown) => onOrderingChange(data, "record_date"),
      style: "text",
      title: "Record Date",
      tdBodyProps: {
        textProps: {
          weight: 600,
        },
      },
    },
    filingDate: {
      sort: getSort("filing_date"),
      sortFn: (data: unknown) => onOrderingChange(data, "filing_date"),
      style: "text",
      title: "Filing Date",
    },
    chapter: {
      sort: getSort("chapter"),
      sortFn: (data: unknown) => onOrderingChange(data, "chapter"),
      style: "text",
      title: "Chapter",
    },
    claimsAdministrator: {
      style: "text",
      title: "Claims Administrator",
    },
  };
}

export function getRowData(
  events: IBankruptcyEvent[],
  onRowClick: (event: IBankruptcyEvent) => void
): Row[] {
  const handleRowClick = (data: unknown) => {
    const { event } = data as {
      event: IBankruptcyEvent;
      idx: string;
    };
    onRowClick(event);
  };

  return events.map((event, idx) => {
    const { id, recordDate, filingDate, chapter, claimsAdministrator } = event;

    return {
      id,
      data: { event, idx },
      rowData: {
        recordDate: {
          content: recordDate ? dayjs(recordDate).format("MM/DD/YYYY") : "-",
          clickHandler: handleRowClick,
        },
        filingDate: {
          content: filingDate ? dayjs(filingDate).format("MM/DD/YYYY") : "-",
          clickHandler: handleRowClick,
        },
        chapter: {
          content:
            BANKRUPTCY_CHAPTER_LABEL[chapter as BankruptcyChapter] ||
            chapter ||
            "-",
          clickHandler: handleRowClick,
        },
        claimsAdministrator: {
          content: claimsAdministrator?.name || "-",
          clickHandler: handleRowClick,
        },
      },
    };
  });
}
